import { ISeedsDto } from "../dtos/seeds";
import { Units } from "../enums/units";
import { parseSeedUnits } from "../utils/parse-seed-units";

export class Seed {
  readonly id: string;
  name: string;
  unit?: (typeof Units)[keyof typeof Units];
  units: string[] = [];
  isDeleted: boolean;
  cropIds: string[] = [];
  sortName: string | null = null;
  varietyName: string | null = null;
  reproduction: string | null = null;
  updatedAt: string | null = null;
  updatedByUserId: string | null = null;

  constructor(id: string) {
    this.id = id;
  }

  get availableUnits(): string[] {
    if (this.units.length) {
      return this.units;
    }
    return this.unit ? [this.unit] : [];
  }

  get asDto(): ISeedsDto {
    return {
      id: this.id,
      name: this.name,
      sortName: this.sortName,
      varietyName: this.varietyName,
      units: JSON.stringify(this.units),
      unit: this.unit,
      isDeleted: this.isDeleted,
      crops: this.cropIds.length ? this.cropIds.map((id) => ({ id })) : undefined,
      reproduction: this.reproduction ?? undefined,
      updatedAt: this.updatedAt ?? undefined,
      updatedByUserId: this.updatedByUserId ?? undefined,
    };
  }

  updateFromDto(dto: ISeedsDto): void {
    this.name = dto.name;
    this.units = parseSeedUnits(dto.units);
    this.unit = dto.unit;
    this.isDeleted = dto.isDeleted || false;
    const rawCropIds = dto.cropIds ?? dto.crops?.map((crop) => crop.id) ?? [];
    this.cropIds = [...new Set(rawCropIds.map((id) => id.toLowerCase()))];
    this.sortName = dto.sortName ?? null;
    this.varietyName = dto.varietyName ?? null;
    this.reproduction = dto.reproduction ?? null;
    this.updatedAt = dto.updatedAt ?? null;
    this.updatedByUserId = dto.updatedByUserId ?? null;
  }

  clone(): Seed {
    return Object.assign(new Seed(this.id), this);
  }
}
